import React, { useState } from 'react';

import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { ChartTemplateTableItemT } from './types';
import EditChartTemplateModal from './CreateOrEditChartTemplate/EditChartTemplateModal';
import IconButton from '@mui/material/IconButton';
import ManageChartTemplateProvider from './ManageChartTemplateContext/ManageChartTemplateProvider';
import UpdateIcon from '@mui/icons-material/Edit';

type ActionsCellRendererProps = CellRendererParams<ChartTemplateTableItemT>;

const ActionsCellRenderer = ({
    data,
}: ActionsCellRendererProps): JSX.Element => {
    const [isEditChartTemplateModalOpen, setIsEditChartTemplateModalOpen] =
        useState(false);

    if (!data) return <></>;

    const { key } = data;

    return (
        <>
            <IconButton
                size="small"
                onClick={() => setIsEditChartTemplateModalOpen(true)}
            >
                <UpdateIcon />
            </IconButton>
            {isEditChartTemplateModalOpen && (
                <ManageChartTemplateProvider>
                    <EditChartTemplateModal
                        chartTemplateKey={key}
                        open={isEditChartTemplateModalOpen}
                        setOpen={setIsEditChartTemplateModalOpen}
                    />
                </ManageChartTemplateProvider>
            )}
        </>
    );
};

export default ActionsCellRenderer;
